import { render, staticRenderFns } from "./ManualMatch.vue?vue&type=template&id=8047251e&scoped=true&"
import script from "./ManualMatch.vue?vue&type=script&lang=js&"
export * from "./ManualMatch.vue?vue&type=script&lang=js&"
import style0 from "./ManualMatch.vue?vue&type=style&index=0&id=8047251e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8047251e",
  null
  
)

export default component.exports